var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import packageJson from '../../package.json';
var version = packageJson.version;
export function getClientSdk(additionalHttpHeaders) {
    var _a;
    var coreAgent = { ANSWERS_CORE: version };
    if (!additionalHttpHeaders) {
        return coreAgent;
    }
    var customClientSdk = (_a = additionalHttpHeaders['Client-SDK']) !== null && _a !== void 0 ? _a : {};
    return Object.entries(customClientSdk).reduce(function (clientSdk, _a) {
        var _b;
        var agent = _a[0], version = _a[1];
        return version
            ? __assign(__assign({}, clientSdk), (_b = {}, _b[agent] = version, _b)) : clientSdk;
    }, coreAgent);
}
//# sourceMappingURL=getClientSdk.js.map